// extracted by mini-css-extract-plugin
export default {"star":"recommendations--lmYVc","star--favourite":"recommendations--2jlT7"};